import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const drivertechConfig: TSPConfig = {
  key: 'drivertech',
  name: 'DriverTech',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please request your Data Store from your DriverTech representative.',
  loginComponent: (props: LoginComponentProps) => {
    return (
      <LoginCreds
        onValidityChange={props.onValidityChange}
        fields={[
          { label: 'Username', name: 'username', type: 'text', required: true },
          {
            label: 'Password',
            name: 'password',
            type: 'password',
            required: true,
          },
          {
            label: 'Data Store',
            name: 'database',
            type: 'text',
            required: true,
          },
          {
            label: 'Company Code',
            name: 'authorizationcode',
            type: 'text',
            required: true,
          },
        ]}
      />
    );
  },
};

export default drivertechConfig;
